import 'whatwg-fetch';

import { ApiResponseError } from '@/api/ApiResponseError';
import type { FeatureFlagName } from '@/types';
import { captureError } from '@smg-real-estate/browser-rum';

export type FeatureFlags = {
  [key in FeatureFlagName]: string;
};

export interface FeatureFlagsResponse {
  data: {
    treatmentsWithConfig: {
      [key in FeatureFlagName]: {
        treatment: string;
      };
    };
  };
}

const FEATURE_FLAGS_TIMEOUT_MS = 5000;

export async function getFeatureFlags(flagSets: string[]): Promise<FeatureFlagsResponse> {
  const params = new URLSearchParams();
  flagSets.forEach((flagSet) => params.append('flags[]', flagSet));
  const url = `${import.meta.env.VUE_APP_API_DOMAIN}/experiments/feature-flags?${params.toString()}`;

  const controller = new AbortController();
  const timeoutId = setTimeout(() => controller.abort(), FEATURE_FLAGS_TIMEOUT_MS);

  try {
    const response = await fetch(url, {
      method: 'GET',
      mode: 'cors',
      credentials: 'include',
      signal: controller.signal,
    });
    return response.json();
  } catch (error) {
    captureError(error, { service: 'experiments' });
    throw new ApiResponseError(error.message, error.status);
  } finally {
    clearTimeout(timeoutId);
  }
}
